var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c("SidebarHeader"),
      _vm._v(" "),
      _c("SidebarForm"),
      _vm._v(" "),
      _c(
        "nav",
        { staticClass: "sidebar-nav" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "nav" },
            [
              _vm._l(_vm.navItems, function (item) {
                return [
                  item.title
                    ? [
                        _c("SidebarNavTitle", {
                          key: item.name,
                          attrs: {
                            name: item.name,
                            classes: item.class,
                            wrapper: item.wrapper,
                          },
                        }),
                      ]
                    : item.divider
                    ? [_c("li", { key: item.name, staticClass: "divider" })]
                    : [
                        item.children
                          ? [
                              _c(
                                "SidebarNavDropdown",
                                {
                                  key: item.name,
                                  attrs: {
                                    name: item.name,
                                    url: item.url,
                                    icon: item.icon,
                                  },
                                },
                                [
                                  _vm._l(item.children, function (childL1) {
                                    return [
                                      childL1.children
                                        ? [
                                            _c(
                                              "SidebarNavDropdown",
                                              {
                                                key: childL1.name,
                                                attrs: {
                                                  name: childL1.name,
                                                  url: childL1.url,
                                                  icon: childL1.icon,
                                                },
                                              },
                                              _vm._l(
                                                childL1.children,
                                                function (childL2) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: childL2.name,
                                                      staticClass: "nav-item",
                                                    },
                                                    [
                                                      _c("SidebarNavLink", {
                                                        key: childL2.name,
                                                        attrs: {
                                                          name: childL2.name,
                                                          url: childL2.url,
                                                          icon: childL2.icon,
                                                          badge: childL2.badge,
                                                          variant: item.variant,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "SidebarNavItem",
                                              {
                                                key: childL1.name,
                                                attrs: { classes: item.class },
                                              },
                                              [
                                                _c("SidebarNavLink", {
                                                  attrs: {
                                                    name: childL1.name,
                                                    url: childL1.url,
                                                    icon: childL1.icon,
                                                    badge: childL1.badge,
                                                    variant: item.variant,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ]
                          : [
                              _c(
                                "SidebarNavItem",
                                {
                                  key: item.name,
                                  attrs: { classes: item.class },
                                },
                                [
                                  _c("SidebarNavLink", {
                                    attrs: {
                                      name: item.name,
                                      url: item.url,
                                      icon: item.icon,
                                      badge: item.badge,
                                      variant: item.variant,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                      ],
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("SidebarFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }